import React from 'react';
import './header.css'

function Header() {
  return (
    <header>
      
    <div className='header'>
      <img className='header-logo pointer' src='./images/nepal_logo.png' alt='logo'/>
      <span className='header-title'>
        <p>Nepal Government</p>
        <p>Ministry of Energy and Water Resources and Irrigation</p>
        <p>Department of Water Resources and Irrigation</p>
        <p>Nagmati Dam project</p>
        <p>Jawalakhel, Lalitpur</p>
      </span>
      <img className='header-logo right' src='./images/nepal_flag.gif' alt='flag'/>
    </div>
    </header>

  );
}

export default Header;